import { createSelector } from 'reselect'
import { getNextItemAndSong, getPreviousItemAndSong } from 'reducers/PlayQueue'

const selectPlayer = (state) => state.player
const selectPlayQueue = (state) => state.playQueue

export const makeSelectPlayerState = () =>
  createSelector([selectPlayer, selectPlayQueue], (player, playQueue) => {
    const { song, isPlaying, currentTime, duration } = player
    const hasPreviousSong = getPreviousItemAndSong(playQueue).song != null
    const hasNextSong = getNextItemAndSong(playQueue).song != null

    return {
      isPlaying,
      currentTime,
      seekTime: player.seekTime,
      playerDuration: player.duration,
      displayDuration: duration || 0,
      selectedSong: song || {},
      coverArt: song?.coverart,
      releaseid: song?.releaseid && String(song.releaseid),
      playQueue,
      hasNextSong,
      hasPreviousSong,
      volume: player.volume,
      previousVolume: player.previousVolume,
      isMuted: player.isMuted,
      autoPlay: player.autoPlay
    }
  })
